export const Data1 = [
    {
        skill: 'HTML',
        yet: 100,
        basics: 150,
        Intermediate: 106,
        Good: 106
      },
      {
        skill: 'CSS',
        yet: 148,
        basics: 137,
        Intermediate: 103,
        Good: 74
      },
      {
        skill: 'JavaScript',
        yet: 251,
        basics: 126,
        Intermediate: 59,
        Good: 26
      },
      {
        skill: 'React js',
        yet: 343,
        basics: 85,
        Intermediate: 26,
        Good: 8
      },
      {
        skill: 'Node js',
        yet: 362,
        basics: 78,
        Intermediate: 15,
        Good: 7
      },
      {
        skill: 'MongoDB',
        yet: 380,
        basics: 68,
        Intermediate: 6,
        Good: 8
    } 
];

export const Data2 = [
    {
        skill: 'HTML',
        yet: 0,
        basics: 10,
        Intermediate: 52,
        Good: 400
    },
    {
        skill: 'CSS',
        yet: 0,
        basics: 10,
        Intermediate: 52,
        Good: 400
    },
    {
        skill: 'JavaScript',
        yet: 0,
        basics: 40,
        Intermediate: 192,
        Good: 230
    },
    {
        skill: 'React js',
        yet: 0,
        basics: 50,
        Intermediate: 170,
        Good: 242
        },
        {
        skill: 'Node js',
        yet: 0,
        basics: 60,
        Intermediate: 202,
        Good: 200
        },
        {
        skill: 'MongoDB',
        yet: 0,
        basics: 22,
        Intermediate: 140,
        Good: 300
        }
    ];  